export const navItems = [
  { to: "/", label: "Overview" },
  { to: "/agents", label: "Agents" },
  { to: "/catalogue", label: "Catalogue" },
  { to: "/campaigns", label: "Campaigns" },
  { to: "/alerts", label: "Alerts" },
] as const;
